import { useState } from "react";
import { Metric, Section, usePoll, fmtBytes } from "@/components/monitor/shared";

export function DbTab() {
  const { data } = usePoll("/admin/monitor/db", 15000);
  if (!data) return <div className="text-sm text-slate-500">Yükleniyor...</div>;
  const r = data.reading, s = data.stats || {};
  return (
    <div className="space-y-5" data-testid="monitor-db">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <Metric testId="db-status" label="Bağlantı" value={r.db_ok ? "Bağlı" : null} tone={r.db_ok ? "ok" : "bad"} unsupported="Bağlantı yok" hint={r.db_error} />
        <Metric testId="db-ping" label="Ping" value={r.db_ping_ms != null ? `${r.db_ping_ms} ms` : null} />
        <Metric testId="db-query" label="İndeksli sorgu süresi" value={r.db_query_ms != null ? `${r.db_query_ms} ms` : null} />
        <Metric testId="db-conn" label="Açık bağlantı" value={r.db_conn} unsupported="Desteklenmiyor" />
        <Metric testId="db-data" label="Veri boyutu" value={fmtBytes(s.dataSize)} unsupported="Desteklenmiyor" />
        <Metric testId="db-storage" label="Disk üzerindeki boyut" value={fmtBytes(s.storageSize)} unsupported="Desteklenmiyor" />
        <Metric testId="db-index" label="İndeks boyutu" value={fmtBytes(s.indexSize)} hint={s.indexes != null ? `${s.indexes} indeks` : null} unsupported="Desteklenmiyor" />
        <Metric testId="db-mem" label="Veritabanı belleği" value={r.db_resident_mb != null ? `${r.db_resident_mb} MB` : null} unsupported="Desteklenmiyor" />
      </div>
      <Section title="Koleksiyonlar (yalnızca sayı ve boyut)" testId="db-collections">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs">{["Koleksiyon", "Kayıt", "Boyut", "Disk", "İndeks"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>{data.collections.map((c) => (
              <tr key={c.name} className="border-t border-slate-100" data-testid={`coll-${c.name}`}>
                <td className="px-3 py-2 font-mono text-xs">{c.name}</td><td className="px-3 py-2">{c.count?.toLocaleString("tr-TR")}</td>
                <td className="px-3 py-2">{fmtBytes(c.size) ?? "-"}</td><td className="px-3 py-2">{fmtBytes(c.storage) ?? "-"}</td>
                <td className="px-3 py-2">{c.indexes ?? "-"} · {fmtBytes(c.index_size) ?? "-"}</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </Section>
      <p className="text-[11px] text-slate-400">Bu ekran ofislerin müşteri veya portföy içeriklerini okumaz; yalnızca istatistik gösterir. Bağlantı adresi gösterilmez.</p>
    </div>
  );
}

export function ApiTab() {
  const [hours, setHours] = useState(24);
  const { data } = usePoll("/admin/monitor/api", 60000, { hours });
  return (
    <Section title="Modül bazında API performansı" testId="monitor-api" right={
      <select data-testid="api-hours" value={hours} onChange={(e) => setHours(Number(e.target.value))} className="h-8 rounded-lg border border-slate-200 px-2 text-xs bg-white">
        {[[1, "Son 1 saat"], [24, "Son 24 saat"], [168, "Son 7 gün"], [720, "Son 30 gün"]].map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>}>
      {!data ? "Yükleniyor..." : data.modules.length === 0 ? <div className="text-sm text-slate-400">Bu aralıkta kayıtlı istek yok</div> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs">{["Modül", "İstek", "Ortalama", "En yüksek p95"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
            <tbody>{data.modules.map((m) => (
              <tr key={m.module} className="border-t border-slate-100" data-testid={`api-mod-${m.module}`}>
                <td className="px-3 py-2 font-mono text-xs">{m.module}</td><td className="px-3 py-2">{m.requests.toLocaleString("tr-TR")}</td>
                <td className="px-3 py-2">{m.avg_ms} ms</td>
                <td className={`px-3 py-2 font-semibold ${m.p95_max_ms >= 1500 ? "text-red-600" : m.p95_max_ms >= 800 ? "text-amber-600" : "text-emerald-700"}`}>{m.p95_max_ms} ms</td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      )}
    </Section>
  );
}
